import React from 'react';
import cs from 'classnames';
import {push as changeURL} from 'react-router-redux';
import trim from 'lodash/trim';

import store from '~/store';
import Button from '~/components/common/Button';
import PerchaseTerms from '../PerchaseTerms';
import {errorInfoConfig} from '~/misc/error-info';
import {createOrderAction} from '~/modules/hp/actions';
import LoadingSpiner from '~/components/pages/MyAccount/share/LoadingSpiner';
import {track} from '~/misc/metrics';
import {centTo$} from '~/misc/formatMoney';
// import vipShownameTransfer from '~/components/pages/vipShownameTransfer.js';

import css from './index.css';
import sharedCss from '../index.css';

class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 4,
      haveReadPerchaseTerms: false,
      readPerchaseError: '',
      haveReadPaymentInfo: false,
      readPaymentError: '',
      signature: '',
      signatureError: '',
    };
    this.changeReadPerchaseValue = this.changeReadPerchaseValue.bind(this);
    this.changeReadPaymentValue = this.changeReadPaymentValue.bind(this);
    this.changeHandle = this.changeHandle.bind(this);
    this.blurHandle = this.blurHandle.bind(this);
    this.goToBack = this.goToBack.bind(this);
    this.goToNext = this.goToNext.bind(this);
  }

  componentWillMount() {
    window.scrollTo(0, 0);
    this.props.changeNavItem(this.state.currentStep);
    const data = Object.assign(this.state, this.props.parentState.formData.step4);
    return this.setState({
      ...data,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.hp.createOrder.data && nextProps.hp.createOrder.data) {
      const { query } = this.props.parentState
      const memberShipData = this.props.parentState.formData.step2.formData.product.pay_option.key;
      const [cycle, level ] = memberShipData.includes('_') ? memberShipData.split('_') : ['', ''];
      const orderId = nextProps.hp.createOrder.data.order_id;
      const businessCode = nextProps.hp.createOrder.data.business_code;
      store.dispatch(changeURL(`/pending-payment?business_code=${businessCode}&order_id=${orderId}&cycle=${cycle}&level=${level}${query.from ? ('&source='+query.from) : ''}`));
    }
  }

  render() {
    const orderInfo = this.props.parentState.formData.step2.formData.product;
    const step1FormData = this.props.parentState.formData.step1.formData;
    const userName = `${step1FormData.basicFirstName} ${step1FormData.basicLastName}`;
    const createOrderError = this.props.hp.createOrder.error;
    const createOrderLoading = this.props.hp.createOrder.loading;
    // const planModes = this.props.parentState.formData.step2.planModes[0].grade_option.show_name;
    const plan = this.props.parentState.formData.step2.planModes[0].grade_name
    const cycle = this.props.parentState.formData.step2.planModes[0].bill_cycle

    return (
      <div className={css.wrap}>
        <div className={css.header}>
          <div className={css.tit}>Dear {userName}</div>
          <p className={css.p}>Thank you for choosing us. Please take a moment to finish your order.</p>
        </div>
        <div className={css.body}>
          <div className={cs(css.tit, css.summary)}>Order Summary</div>
          <div className={css.fill}>Total to be charged for first time</div>
          <div className={css.partSummary}>
            <ul className={css.productWrap}>
              <li className={css.thWrap}>
                <div>Product</div>
                <div>Price</div>
              </li>
              <li className={css.tdWrap}>
                <div className={css.opacity4}>
                  <span className={css.capitalize}>{plan}</span>{' '}
                  - Billed {cycle} </div>
                <div>${centTo$(orderInfo.discount_price)}</div>
              </li>
              <li className={css.tdWrap}>
                <div className={css.opacity4}>Users <span> x </span>{orderInfo.seat_num}</div>
                <div>{' '}</div>
              </li>
              <li className={cs(css.thWrap, css.marginTop10)}>
                <div>First Time Total Payment</div>
                <div className={css.redColor}>${centTo$(Number(orderInfo.seat_num) * orderInfo.discount_price)}</div>
              </li>
            </ul>
            <p className={cs(css.p, css.removeMg, css.justify, css.marginTop5)}>
              (Your payment will start once your payment is received)<br/>
            </p>
          </div>
          <div className={css.termsWrap}>
            <div className={cs(css.tit, css.summary)}>Purchase Terms</div>
            <div className={css.termsContainer}>
              <PerchaseTerms />
            </div>
            <div className={cs(sharedCss.check, css.check)}>
              <div
                className={cs(css.checkBox, this.state.haveReadPerchaseTerms && css.checkedBorder)}
                onClick={this.changeReadPerchaseValue}
              >
                <span className={this.state.haveReadPerchaseTerms && css.chckedStyle} />
              </div>
              <p className={sharedCss.opacity}>I have read and accept the Purchase Terms.</p>
              {this.state.readPerchaseError
                && <span className={sharedCss.errorTips}>{this.state.readPerchaseError}</span>
              }
            </div>
          </div>
          <div className={css.payInfo}>
            <div className={css.payBank}>
              <div>
                <div className={cs(css.tit)}>Payment Info</div>
                <p className={cs(css.removeMg, css.pd)}>Pay with your credit card via Stripe.</p>
              </div>
              <img src='/assets/Bank_icon.png' className={css.bankIcon}/>
            </div>
            <div className={cs(sharedCss.check, css.check)}>
              <div
                className={cs(css.checkBox, this.state.haveReadPaymentInfo && css.checkedBorder)}
                onClick={this.changeReadPaymentValue}
              >
                <span className={this.state.haveReadPaymentInfo && css.chckedStyle} />
              </div>
              <p>
                <span className={sharedCss.opacity}>I have read and accept</span>{' '}
                <a target='_blank' href='https://stripe.com/payment-terms/legal'>Stripe Payment Terms</a>
                .
              </p>
              {this.state.readPaymentError
                && <span className={sharedCss.errorTips}>{this.state.readPaymentError}</span>
              }
            </div>
          </div>
          <div className={css.signWrap}>
            <div className={cs(css.tit)}>Signature</div>
            <div className={css.inputWrap}>
              <input
                className={css.signInput}
                value={this.state.signature}
                onChange={this.changeHandle}
                onBlur={this.blurHandle}
                type='text'
              />
              {this.state.signatureError
                && (<span className={cs(sharedCss.errorTips, css.bottomPayment)}>{this.state.signatureError}</span>)
              }
            </div>
            <p className={cs(sharedCss.opacity, css.removeMg, css.justify)}>
              By typing your name in the signature box you agree that you are
              (or by typing your name in the signature box on behalf of a legal entity,
              you agree that such entity is) legally bound by Terms and Conditions,
              pricing information and other provisions above.
            </p>
          </div>
          <div className={sharedCss.btnWrap}>
            <Button className={cs(sharedCss.wide)} mods={['large']} onClick={this.goToBack}>Back</Button>
            {this.state.signature
              && this.state.haveReadPerchaseTerms
              && this.state.haveReadPaymentInfo
              ? (<Button
                className={cs(sharedCss.marginLef, sharedCss.wide, css.loadingWrap)}
                mods={['large', 'action']}
                onClick={this.goToNext}
              >{this.renderBtnContent(createOrderLoading)}</Button>)
              : (<Button
                className={cs(sharedCss.marginLef, sharedCss.wide)}
                mods={['large']}
                onClick={this.goToNext}
              >Next</Button>)
            }
            {createOrderError
              && <span className={cs(sharedCss.errorTips, css.bottomPayment, css.left50)}>{createOrderError}</span>
            }
          </div>
        </div>
      </div>
    );
  }

  renderBtnContent(loading) {
    if (loading) {
      return (
        <LoadingSpiner/>
      );
    }
    return 'Next';
  }

  goToBack() {
    this.props.changeStep(this.state.currentStep - 1);
    setTimeout(() => {
      this.props.setStepData(this.state.currentStep, this.state);
      store.dispatch(changeURL(this.props.parentState.navItem[this.props.parentState.step - 1].routing));
    }, 300);
  }

  goToNext() {
    track('payment', {'payment - 4': 1});
    this.judgeEmpty();
    const val = this.props.parentState.formData;
    if (this.state.haveReadPerchaseTerms
      && this.state.haveReadPaymentInfo
      && !this.state.signatureError && this.state.signature) {
      val['account_id'] = this.props.hp.saveBsicInfo.data && this.props.hp.saveBsicInfo.data.id;
      store.dispatch((dispatch, getState) => createOrderAction(dispatch, getState, val));
      setTimeout(() => {
        this.props.setStepData(this.state.currentStep, this.state);
      }, 500);
    }
  }

  changeCheckBox(e) {
    if (e.target.checked) {
      return this.setState({
        haveRead: true,
        readError: '',
      });
    }
    return this.setState({
      haveRead: false,
      readError: '',
    });
  }

  blurHandle(e) {
    let error = '';
    const firstName = trim(this.props.parentState.formData.step1.formData.basicFirstName);
    const lastName = trim(this.props.parentState.formData.step1.formData.basicLastName);
    const userName = `${firstName} ${lastName}`;
    const inputValue = trim(e.target.value);
    if (inputValue) {
      if (inputValue !== userName) {
        error = errorInfoConfig.signText.wrong;
      }
    } else {
      error = errorInfoConfig.signText.empty;
    }
    return this.setState({
      signature: inputValue,
      signatureError: error,
    });
  }
  changeHandle(e) {
    return this.setState({
      signature: e.target.value,
      signatureError: '',
    });
  }
  changeReadValue(type, error) {
    return this.setState({
      [type]: !this.state[type],
      [error]: this.state[type] ? errorInfoConfig.readTerms.empty : '',
    });
  }

  changeReadPerchaseValue() {
    return this.changeReadValue('haveReadPerchaseTerms', 'readPerchaseError');
  }

  changeReadPaymentValue() {
    return this.changeReadValue('haveReadPaymentInfo', 'readPaymentError');
  }

  judgeEmpty() {
    let signatureError;

    if (this.state.signature && this.state.signatureError) {
      signatureError = this.state.signatureError;
    } else if (this.state.signature && !this.state.signatureError) {
      signatureError = '';
    } else {
      signatureError = errorInfoConfig.signText.empty;
    }

    return this.setState({
      readPaymentError: this.state.haveReadPaymentInfo ? '' : errorInfoConfig.readTerms.empty,
      readPerchaseError: this.state.haveReadPerchaseTerms ? '' : errorInfoConfig.readTerms.empty,
      signatureError: signatureError,
    });
  }
}

export default Payment;



// WEBPACK FOOTER //
// ./src/components/pages/PaymentProcess/Payment/index.js